import { fetchData } from '@signal/core/swr/fetch'
import { readCookie } from '@signal/utils/cookies'
import getAPIDomain from '@signal/utils/env/apiDomain'
/* webpack-strip-block:removed */
import buildInfo from './build-info.json'
import { InjectedOnSiteOfferType } from '@purecars-kubical/on-site-integration/on-site-offers/data/offer-data'

/**
 * injects the on-site offer, if present for this site
 *
 * THIS IS THE ENTRY POINT FOR THE INJECTOR - inject.ts
 */
export async function injectOnSiteOffer(
  appendTo: HTMLElement = document.body,
  /* webpack-strip-block:removed */
) {
  // @ts-ignore
  const pureCarsConfig = window._pureCarsV2 || window._pureCars || {}
  // @ts-ignore
  const accountId = pureCarsConfig.guid
  if (accountId) {
    const pcuid = readCookie('_pcUID')

    // obtain the offer response, if any, for this account/pcuid pair
    const response =
      /* webpack-strip-block:removed */
      (await fetchData<InjectedOnSiteOfferType>({
        url: `${getAPIDomain(
          '/on-site-integration/api'
        )}/v1/serve/${accountId}/${pcuid}`,
        options: { credentials: 'omit' }
      }))

    // this condition is true when the response is actual JSON offer data, not an empty 200 response
    if (!(response instanceof Response) && Boolean(response.adJsUrl)) {
      // provide this offer data to the bundle once it injects
      // @ts-ignore
      window._pureCarsOfferData = {
        ...response,
        accountId
      }

      // inject the onsite offer
      const script = document.createElement('script')
      script.src = `${response.adJsUrl}?v=${buildInfo.version}`
      appendTo.appendChild(script)
    }
  }
}

/* webpack-strip-block:removed */
  injectOnSiteOffer()
  /* webpack-strip-block:removed */
